export default {
      id: "home_background-usage",
      viewBox: "0 0 743 1281",
      url: __webpack_public_path__ + "img/icons.14f187a1.svg#home_background",
      toString: function () {
        return this.url;
      }
    }